export default "__VITE_ASSET__CS$Uda79__"